import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { LoadingButton } from '@atlaskit/button';

import { LoadableAfterPaint } from '@confluence/loadable';

import type { RequestToEditComponentProps } from './RequestToEdit.tsx';

const i18n = defineMessages({
	requestToEdit: {
		defaultMessage: 'Request to edit',
		description:
			'This is the placeholder label for a button that allows a user with view only permission to request edit permission. On click of this button an email is sent to the content owner for approval.',
		id: 'no-permission.request.to.edit.button.placeholder.label',
	},
});

const RequestToEditPlaceholder = () => {
	const intl = useIntl();

	return <LoadingButton isDisabled>{intl.formatMessage(i18n.requestToEdit)}</LoadingButton>;
};

export const RequestToEditLoaderAfterPaint = LoadableAfterPaint<RequestToEditComponentProps>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RequestToEditLoader" */ './RequestToEdit.tsx'))
			.RequestToEdit,
	loading: () => <RequestToEditPlaceholder />,
});
